// Lib
import React from 'react';
import PropTypes from 'prop-types';

// Components
import TrashPopupPersonalTab from './TrashPopupPersonalTab';
import TrashPopupOthersTab from './TrashPopupOthersTab';

// Constants
import { TRASH_TABS } from '../../store/trashConstants';

const TrashPopupTabSwitch = (props) => {
    const { activeTab } = props;

    switch (activeTab) {
        case TRASH_TABS.OTHERS:
            return <TrashPopupOthersTab {...props} />;
        default:
            return <TrashPopupPersonalTab {...props} />;
    }
};

TrashPopupTabSwitch.propTypes = {
    activeTab: PropTypes.string,
};

export default TrashPopupTabSwitch;
